import React, { useState } from "react";
import { InlineWidget } from "react-calendly";
import { useTranslation, Trans } from "react-i18next";

const CalendlyPopup = () => {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="calendly-wrapper" id="contact">
      <div className="calendly-content">
        <h2>
          <Trans i18nKey="calendly.title">
            GET IN TOUCH FOR <span className="highlight">consultation</span> today and take the
            first step toward success!
          </Trans>
        </h2>
        <button className="btn" onClick={handleOpenPopup}>{t("calendly.btn")}</button>
      </div>
      <div className="calendly-image">
        <img 
          src="/images/calendly.svg" 
          alt="Calendar" 
          onClick={handleOpenPopup}
          role="button" 
          aria-label="Open Calendly"
        />
      </div>

      {showPopup && (
        <div 
          className="calendly-popup" 
          role="dialog"
          aria-labelledby="calendly-popup-title"
          aria-hidden={!showPopup} 
        >
          <div 
            className="calendly-popup-content" 
            role="document"
          >
            <button onClick={handleClosePopup}  className="btn" aria-label="Close the popup">Close</button>
            <InlineWidget url="https://calendly.com/cheshk_farzad2012/coaching?" className="widget"/>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendlyPopup;
